import { render } from "./AppRequests.vue?vue&type=template&id=947b17de&scoped=true"
import script from "./AppRequests.vue?vue&type=script&lang=js"
export * from "./AppRequests.vue?vue&type=script&lang=js"

import "./AppRequests.vue?vue&type=style&index=0&id=947b17de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947b17de"]])

export default __exports__